import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{attrs:{"id":"app"}},[_c(VMain,[_c('NavTop'),_c('router-view'),_c('NavBottom')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }